<script lang="ts">
	import Container from '@components/global/Container.svelte';
	import ProfileRow from '@components/app/ProfileRow.svelte';
	import ListAndFilterSection from '@components/app/search/ListAndFilterSection.svelte';

	export let data;

	const { writer: profile } = data;

	$: ({ books, totalItems, totalPages } = data);
</script>

<section>
	<ProfileRow {profile} />
	<Container class="py-6">
		<ListAndFilterSection
			{books}
			{totalItems}
			{totalPages}
			alternateParamsFilter={{ writer_id: String(profile.id) }}
		/>
	</Container>
</section>
